export type MapperSearch = {
  mapperTab?: 'matches' | 'approval';
  countries?: string[];
  search?: string;
  productsPage?: number;
  hotelsPage?: number;
  middlePage?: number;
};

export const MAPPER_PAGE_SIZE = 10;

const TABS = new Set<MapperSearch['mapperTab']>(['matches', 'approval']);

const coerceStringArray = (raw: unknown): string[] | undefined => {
  if (Array.isArray(raw)) return raw.filter((v) => typeof v === 'string');
  if (typeof raw === 'string' && raw.length > 0) return raw.split(',');
  return undefined;
};

const coercePositiveInt = (raw: unknown): number | undefined => {
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : undefined;
};

export const validateMapperSearch = (
  input: Record<string, unknown>
): MapperSearch => ({
  mapperTab: TABS.has(input.mapperTab as MapperSearch['mapperTab'])
    ? (input.mapperTab as MapperSearch['mapperTab'])
    : undefined,
  countries: coerceStringArray(input.countries),
  search:
    typeof input.search === 'string' && input.search.length > 0
      ? input.search
      : undefined,
  productsPage: coercePositiveInt(input.productsPage),
  hotelsPage: coercePositiveInt(input.hotelsPage),
  middlePage: coercePositiveInt(input.middlePage),
});

export const mergeMapperSearch = (
  prev: MapperSearch,
  next: Partial<MapperSearch>
): MapperSearch => {
  const merged: MapperSearch = { ...prev, ...next };
  // Drop undefined / empty values so URL stays clean.
  if (merged.countries && merged.countries.length === 0)
    merged.countries = undefined;
  if (merged.search === '') merged.search = undefined;
  return merged;
};

export const toFindInput = (
  s: MapperSearch,
  pageKey: 'productsPage' | 'hotelsPage' | 'middlePage'
) => ({
  countries: s.countries,
  search: s.search,
  limit: MAPPER_PAGE_SIZE,
  offset: ((s[pageKey] ?? 1) - 1) * MAPPER_PAGE_SIZE,
});
